import React from 'react';
import { ComposableForm } from '../../CustomFields/ComposableForm';
import useEmailTemplateFormConfig from 'src/hooks/useEmailTemplateFormConfig/useEmailTemplateFormConfig';
import EmailTemplateBody from './EmailDrawerBody';

interface EmailDrawerWrapperProps {
  templateId?: string,
  toggleDrawer: () => void,
}

const EmailDrawerWrapper: React.FC<EmailDrawerWrapperProps> = (props) => {
  const { templateId, toggleDrawer } = props
  const formConfig = useEmailTemplateFormConfig(templateId)

  return (
    <ComposableForm {...formConfig} referenceObject={formConfig.emailTemplateORM}>
      <EmailTemplateBody templateId={templateId} toggleDrawer={toggleDrawer}/>
    </ComposableForm>
  )
}

export default EmailDrawerWrapper;
